module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "order-step-2__col order-step-2__col-1"
  }, [_c('div', {
    staticClass: "order-step-2__text-container text-container inverted-colors"
  }, [_c('h3', [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), (_vm.mode === 'business') ? _c('p', [_vm._v("Bei einer Bürogrösse von mehr als 50 Mitarbeitenden beraten wir euch gerne persönlich. "), _c('a', {
    staticClass: "text",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.toggleQuoteModalVisible.apply(null, arguments)
      }
    }
  }, [_vm._v("Hier weiter zum Formular.")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "range-slider"
  }, [_c('span', {
    staticClass: "range-slider__number range-slider__number--selected"
  }, [_vm._v(_vm._s(_vm.people))]), _vm._v(" "), _c('input', {
    staticClass: "range-slider__input",
    attrs: {
      "name": "people",
      "type": "range",
      "min": _vm.min,
      "max": _vm.max
    },
    domProps: {
      "value": _vm.people
    },
    on: {
      "input": _vm.updatePeople
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "range-slider__number range-slider__number--total"
  }, [_vm._v(_vm._s(_vm.max))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2e0244d4","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./static/js/Order/components/People.vue
// module id = 734
// module chunks = 0